import React from "react";
import { Form } from "react-bootstrap";

const DeliveryRequestTypeSelect = ({ name,label, value, onLocationChange }) => {
  return (
    <Form.Group className="custom-form">
      <Form.Label className="color-head">{label}</Form.Label>
      <Form.Control
        as="select"
        name={name}
        className="py-0"
        value="LOCAL"
        onChange={onLocationChange}
        disabled
      >
        <option value="LOCAL">Local Delivery</option>
      </Form.Control>
    </Form.Group>
  );
};

export default DeliveryRequestTypeSelect;
